<template>
  <v-container fluid class="pa-4">
    <v-card class="elevation-6 rounded-lg">
      <!-- Header -->
      <v-toolbar color="#F5F5F5" flat dense>
        <v-toolbar-title class="text--primary font-weight-bold" style="color:#607D8B">
          <v-icon left color="#607D8B">mdi-lock-reset</v-icon>
          Génération OTP
        </v-toolbar-title>
      </v-toolbar>

      <!-- Loading overlay -->
      <v-dialog v-model="loading" fullscreen>
        <v-overlay color="rgba(200, 200, 200, 0.5)" absolute>
          <v-progress-circular
              indeterminate
              size="70"
              color="#009688"
          ></v-progress-circular>
        </v-overlay>
      </v-dialog>

      <!-- Alerts -->
      <v-card-text>
        <v-alert v-if="type"
                 :color="AlertColor(type)"
                 dismissible
                 @input="dismissible_close"
                 border="left"
                 colored-border
                 elevation="2"
                 icon="mdi-information">
          {{ text }}
        </v-alert>

        <!-- Main content -->
        <v-card flat class="mt-4">
          <v-card class="mx-auto" max-width="400" elevation="2">
            <v-container>
              <v-card flat class="mb-4 elevation-0">
                <v-card-text>
                  <v-row align="center" no-gutters>
                    <v-col cols="8" class="pr-3">
                      <div class="position-relative">
                        <v-text-field
                            :value="matricule"
                            label="Matricule"
                            placeholder="Saisir le matricule"
                            type="text"
                            outlined
                            dense
                            color="#01579B"
                            @input="validateMatricule"
                            @change="bResetGenCodeFct"
                            class="custom-input"
                            hide-details
                        ></v-text-field>
                        <div class="caption text-right grey--text position-absolute" style="right: 12px; bottom: -18px;">
                          {{ matricule.length }} / 10
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <v-btn
                          @click="testCode()"
                          color="#607D8B"
                          dark
                          block
                          height="40"
                          class="search-button text-none"
                          elevation="2"
                      >
                        <v-icon left>mdi-account-search</v-icon>
                        Chercher
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- User info -->
              <v-card outlined class="mb-4 user-info-card">
                <v-card-text>
                  <v-text-field
                      v-model="prenoms"
                      label="Prénom"
                      outlined
                      dense
                      readonly
                      color="#01579B"
                      class="custom-input readonly-field"
                  ></v-text-field>
                  <v-text-field
                      v-model="nom"
                      label="Nom"
                      outlined
                      dense
                      readonly
                      color="#01579B"
                      class="custom-input readonly-field"
                  ></v-text-field>
                  <v-text-field
                      v-model="brigade"
                      label="Brigade"
                      outlined
                      dense
                      readonly
                      color="#01579B"
                      class="custom-input readonly-field"
                  ></v-text-field>
                  <v-text-field
                      v-model="fonction"
                      label="Fonction"
                      outlined
                      dense
                      readonly
                      color="#01579B"
                      class="custom-input readonly-field"
                  ></v-text-field>
                </v-card-text>
              </v-card>

              <!-- Generated code -->
              <v-card class="mb-4 otp-card">
                <v-card-text class="text-center py-6">
                  <div class="text-caption white--text mb-2">CODE GÉNÉRÉ</div>
                  <div class="text-h4 font-weight-bold white--text otp-code">
                    {{ codeGenerated || '••••••' }}
                  </div>
                </v-card-text>
              </v-card>

              <!-- Generate button -->
              <v-btn
                  @click="generateCode()"
                  :disabled="bResetGenCode"
                  block
                  large
                  color="#009688"
                  dark
                  class="elevation-2 generate-btn"
              >
                <v-icon left>mdi-key</v-icon>
                Générer le code
              </v-btn>
            </v-container>
          </v-card>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "codegenerated",
  data: function () {
    return {
      bResetGenCode: true,
      prenoms: "",
      nom: "",
      brigade: "",
      fonction: "",
      matricule: "",
      sigleRestaurateur: "",
      isMobile: isMobileDevice(),
      modaldc: null,
      codeGenerated: "",
      menu2: null,
      type: null,
      elapse: null,
      loading: false,
      loading2: false,
      toObject: [],
      toObjectCmd: [],
      timeMeal: [],
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      colorCmd: "",
      file: "",
      alertCmd: false,
      textCmd: "",
      typeCmd: "",
      bYesMeal: false,
      editedIndex: -1,
      errors: [],
      errorsCmd: [],
      excelData: []
    }
  },
  methods: {
    validateMatricule(value) {
      // Traitement selon le type de l'événement reçu
      let inputValue = '';

      if (typeof value === 'string') {
        inputValue = value;
      } else if (value && value.target && value.target.value !== undefined) {
        inputValue = value.target.value;
      } else {
        return;
      }

      // Vérifier le cas d'une saisie vide
      if (inputValue === '') {
        this.matricule = '';
        return;
      }

      // Vérifier si l'entrée contient uniquement des chiffres
      if (!/^\d+$/.test(inputValue)) {
        // Si des caractères non numériques sont détectés
        this.text = "Seuls les chiffres sont autorisés !";
        this.showAlert('warning', 3000);
        return;
      }

      // Vérifier la longueur
      if (inputValue.length > 10) {
        this.text = "Le matricule ne peut pas dépasser 10 chiffres !";
        this.showAlert('warning', 3000);
        return;
      }

      // Si toutes les validations sont passées, mettre à jour le modèle
      this.matricule = inputValue;
    },

    testCode() {
      // Ne plus vérifier la longueur exacte de 5 caractères
      if (this.matricule.length >= 1 && this.matricule.length <= 10) {
        apiClient
            .get(
                `${this.$store.getters.user.baseUrl}/account/userInfos/` + this.matricule + "/" + sessionStorage.getItem("userId")
            )
            .then(response => {
              let newObj = response.data.data;

              if (newObj !== null) {
                this.nom = newObj.accountLastname
                this.prenoms = newObj.accountFirstname
                this.brigade = newObj.brigade
                this.fonction = newObj.userRoles
                this.bResetGenCode = false
                this.codeGenerated = ""
                return true
              } else {
                this.text = "Ce matricule n'existe pas ou est désactivé !";
                this.showAlert('warning', 5000)
                this.bResetGenCodeFct()
                return false
              }
            })
            .catch(error => {
              this.text = "Erreur récupération compte agent !";
              this.showAlert('warning', 5000)
              this.bResetGenCodeFct()
              console.log("Generation.code.email")
              return false
            });
      } else {
        this.text = "Le matricule doit contenir entre 1 et 10 chiffres !";
        this.showAlert('warning', 5000)
        this.bResetGenCodeFct()
        return false
      }
    },
    bResetGenCodeFct() {
      this.bResetGenCode = true
      this.codeGenerated = ""
    },
    cleared() {
      this.matricule = "";
      this.codeGenerated = "";
    },
    getHour(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${hh}`
    },
    generateCode() {
      let actualDate = moment().format("YYYY-MM-DD").toString()
      let actualHour = moment().format("HH:mm:ss").toString()
      let day = this.getDay(actualDate)
      let hour = this.getHour(actualHour)

      let codeTemp = day + hour + this.digitSum(this.matricule)
      this.codeGenerated = codeTemp.split('').reverse().join('')

      this.text = "Ce code doit être saisi dans les plus brefs délais.\nEn cas de rejet, merci de le regénérer !";
      this.showAlert('info', 20000)

      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/account/savechangepassword/` + this.matricule + "/" + this.codeGenerated + "/" + "ONLY_CODE" + "/INDIRECT/" + sessionStorage.getItem("userId")
          )
          .then(() => {})
          .catch(() => {});
    },
    digitSum(n) {
      return (n % 10 === n) ? n : (this.digitSum(n.toString().split('').reduce((acc, curr) => acc + parseInt(curr), 0)));
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    getDay(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}`
    },
    getMonth(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}`
    },
    getYear(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}`
    },
    onCancel() {
      console.log("User cancelled the loader.")
      this.loading = false
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.dialog = false;
      this.file = "";
      this.searchNameCmd = ""
      this.refresh()
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type, settime) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, settime)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, settime)
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
  },
};
</script>

<style scoped>
/* ========== FONDAMENTAUX ========== */
.v-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
}

.v-card {
  overflow: visible !important;
  border-radius: 12px !important;
}

/* ========== CHAMPS DE SAISIE ========== */
.v-text-field--outlined >>> fieldset {
  border-radius: 6px;
}

.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #01579B !important;
  border-width: 2px;
}

/* ========== CARTE UTILISATEUR ========== */
.user-info-card {
  border-left: 4px solid #01579B;
  background-color: #f8f9fa;
  border-radius: 8px !important;
}

/* ========== CARTE CODE OTP ========== */
.otp-card {
  background: linear-gradient(135deg, #303F9F 0%, #01579B 100%);
  border-radius: 10px !important;
}

.otp-code {
  letter-spacing: 5px !important;
  font-family: 'Roboto Mono', monospace;
}

/* ========== BOUTONS ========== */
.v-btn {
  border-radius: 8px !important;
}

.generate-btn {
  height: 48px !important;
  text-transform: none;
}

/* Positionnement */
.position-relative {
  position: relative;
}

.position-absolute {
  position: absolute;
}

/* Style spécifique pour les champs en lecture seule */
.readonly-field >>> .v-input__slot {
  background-color: #F5F5F5 !important;
  border-left: 3px solid #01579B !important;
}

.readonly-field >>> input {
  color: #455A64 !important;
  font-style: italic;
}

.readonly-field >>> .v-label {
  color: #01579B !important;
  font-weight: 600 !important;
}

/* Indicateur visuel pour les champs en lecture seule */
.readonly-field >>> .v-input__slot::after {
  content: "🔒";
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  opacity: 0.7;
}
</style>